import { render, staticRenderFns } from "./albaran-desplegable-item.vue?vue&type=template&id=c6cac92a&scoped=true&lang=pug"
import script from "./albaran-desplegable-item.vue?vue&type=script&lang=js"
export * from "./albaran-desplegable-item.vue?vue&type=script&lang=js"
import style0 from "./albaran-desplegable-item.vue?vue&type=style&index=0&id=c6cac92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cac92a",
  null
  
)

export default component.exports